// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryTableQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
  statementTypes:
    | Array<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
  compare?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type QueryTableQuery = {
  __typename?: "GraphqlQuery";
  getQueryStats: Array<{
    __typename?: "QuerySummaryStats";
    id: string;
    normalizedQuery: string;
    truncatedQuery: string;
    avgTime: number;
    avgTimeDelta?: number | null;
    callsPerMinute: number;
    callsPerMinuteDelta?: number | null;
    bufferHitRatio?: number | null;
    pctOfTotalIo?: number | null;
    pctOfTotal: number;
    postgresRoleCount: number;
    postgresRole?: {
      __typename?: "PostgresRole";
      id: string;
      name: string;
    } | null;
  }>;
  getServerDetails: { __typename?: "Server"; id: string; humanId: string };
  getPostgresSettingDetails?: {
    __typename?: "PostgresSetting";
    id: string;
    resetValuePrettyNoDelimiter?: string | null;
  } | null;
};

export const QueryTableDocument = gql`
  query QueryTable(
    $databaseId: ID!
    $startTs: Int!
    $endTs: Int!
    $statementTypes: [String!]!
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
    $compare: Boolean
  ) {
    getQueryStats(
      databaseId: $databaseId
      startTs: $startTs
      endTs: $endTs
      statementTypes: $statementTypes
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
      compare: $compare
    ) {
      id
      normalizedQuery
      truncatedQuery
      avgTime
      avgTimeDelta
      callsPerMinute
      callsPerMinuteDelta
      bufferHitRatio
      pctOfTotalIo
      pctOfTotal
      postgresRole {
        id
        name
      }
      postgresRoleCount
    }
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
    }
    getPostgresSettingDetails(
      databaseId: $databaseId
      postgresSettingName: "pg_stat_statements.track"
    ) {
      id
      resetValuePrettyNoDelimiter
    }
  }
`;

/**
 * __useQueryTableQuery__
 *
 * To run a query within a React component, call `useQueryTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryTableQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *      statementTypes: // value for 'statementTypes'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      compare: // value for 'compare'
 *   },
 * });
 */
export function useQueryTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryTableQuery,
    QueryTableQueryVariables
  > &
    (
      | { variables: QueryTableQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryTableQuery, QueryTableQueryVariables>(
    QueryTableDocument,
    options,
  );
}
export function useQueryTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryTableQuery,
    QueryTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QueryTableQuery, QueryTableQueryVariables>(
    QueryTableDocument,
    options,
  );
}
// @ts-ignore
export function useQueryTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryTableQuery,
    QueryTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<QueryTableQuery, QueryTableQueryVariables>;
export function useQueryTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTableQuery,
        QueryTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryTableQuery | undefined,
  QueryTableQueryVariables
>;
export function useQueryTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryTableQuery,
        QueryTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<QueryTableQuery, QueryTableQueryVariables>(
    QueryTableDocument,
    options,
  );
}
export type QueryTableQueryHookResult = ReturnType<typeof useQueryTableQuery>;
export type QueryTableLazyQueryHookResult = ReturnType<
  typeof useQueryTableLazyQuery
>;
export type QueryTableSuspenseQueryHookResult = ReturnType<
  typeof useQueryTableSuspenseQuery
>;
export type QueryTableQueryResult = Apollo.QueryResult<
  QueryTableQuery,
  QueryTableQueryVariables
>;
